import React from "react";

import { faPage, faTag } from "@fortawesome/pro-regular-svg-icons";

import { Dataset } from "src/api/types";
import { Icon, IconVariant } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type Props = {
  source: Dataset["source"];
  hideTooltip?: boolean;
  size?: "2xs" | "xs";
  variant?: IconVariant;
};

export const SourceIcon: React.FC<Props> = ({
  source,
  hideTooltip = false,
  size = "xs",
  variant = "active",
}) => {
  const icon = (
    <Icon
      variant={variant}
      icon={source === "history" ? faTag : faPage}
      size={size}
    />
  );

  if (hideTooltip) {
    return icon;
  }

  return (
    <Tooltip
      placement="top"
      title={
        source === "history"
          ? "This dataset includes a Decision ID"
          : "No Decision ID found in this dataset"
      }
      asChild
    >
      {icon}
    </Tooltip>
  );
};
